/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cat_Ai_TitleInputs */

const tr_faq_cat_ai_title = /** @type {(inputs: Faq_Cat_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapay Zeka ve Krediler`)
};

const en_faq_cat_ai_title = /** @type {(inputs: Faq_Cat_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Features & Credits`)
};

const de_faq_cat_ai_title = /** @type {(inputs: Faq_Cat_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Funktionen und Credits`)
};

const ru_faq_cat_ai_title = /** @type {(inputs: Faq_Cat_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функции ИИ и кредиты`)
};

/**
* | output |
* | --- |
* | "AI Features & Credits" |
*
* @param {Faq_Cat_Ai_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_cat_ai_title = /** @type {((inputs?: Faq_Cat_Ai_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cat_Ai_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_cat_ai_title(inputs)
	if (locale === "de") return de_faq_cat_ai_title(inputs)
	if (locale === "ru") return ru_faq_cat_ai_title(inputs)
	return tr_faq_cat_ai_title(inputs)
});